(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/change-password/components/change-password-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/change-password/components/change-password-form.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  Form
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  PASSWORD_OLD,
  PASSWORD,
  PASSWORD_REPEAT,
  BUTTON_CANCEL_LABEL,
  BUTTON_CONFIRM_LABEL,
  INVALID_PASSWORD_ERROR_MESSAGE,
  PASSWORD_NOT_MATCHING_ERROR_MESSAGE,
  PASSWORD_UPDATED_TITLE,
  PASSWORD_UPDATED_MESSAGE
} = svs.ticket_partner.changePassword.constants.FORMS;
const {
  useState
} = React;
const {
  ButtonRow
} = svs.ticket_partner.sharedComponents.buttonRow;
const validateNewPasswordFormat = password => {
  const passWordReg = /^((?=.*[a-zA-Z])(?=.*\d)(?:[0-9a-zA-Z.@-]){8,18})$/;
  return passWordReg.test(password);
};
const ChangePasswordForm = _ref => {
  let {
    customButtons,
    onCancel,
    onPasswordChanged,
    isVertical = true,
    isLessSpace = false
  } = _ref;
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let {
        isValid
      } = _ref2;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    try {
      await svs.ticket_partner.services.changePassword(oldPassword, password);
      svs.ticket_partner.utils.showSuccessDialog(PASSWORD_UPDATED_MESSAGE, PASSWORD_UPDATED_TITLE, () => {
        setPassword('');
        setOldPassword('');
        setPasswordRepeat('');
        onPasswordChanged();
      });
    } catch (e) {
      svs.ticket_partner.utils.showErrorDialog(svs.ticket_partner.services.changePasswordErrorMapper(e));
    }
    svs.ui.loader.hide();
  };
  const validatePassword = value => {
    const isValid = validateNewPasswordFormat(value);
    return {
      isValid,
      errorMessage: isValid ? '' : INVALID_PASSWORD_ERROR_MESSAGE
    };
  };
  const validateNewPassword = value => {
    const validPassword = validatePassword(value);
    if (validPassword.isValid) {
      const isMatching = value === password;
      return {
        isValid: isMatching,
        errorMessage: isMatching ? '' : PASSWORD_NOT_MATCHING_ERROR_MESSAGE
      };
    }
    return validPassword;
  };
  return React.createElement(Form, {
    isVertical: isVertical,
    onSubmit: handleSubmit
  }, React.createElement(TextInput, {
    "data-testid": PASSWORD_OLD.NAME,
    errorMessageRequired: PASSWORD_OLD.REQUIRED_ERROR,
    id: PASSWORD_OLD.NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: PASSWORD_OLD.LABEL,
    name: PASSWORD_OLD.NAME,
    onChange: e => setOldPassword(e.target.value),
    type: "password",
    value: oldPassword
  }), React.createElement(TextInput, {
    "data-testid": PASSWORD.NAME,
    errorMessageRequired: PASSWORD.REQUIRED_ERROR,
    helpMessage: PASSWORD.HELP,
    id: PASSWORD.NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: PASSWORD.LABEL,
    name: PASSWORD.NAME,
    onChange: e => setPassword(e.target.value),
    type: "password",
    validateFn: validatePassword,
    value: password
  }), React.createElement(TextInput, {
    "data-testid": PASSWORD_REPEAT.NAME,
    errorMessageRequired: PASSWORD_REPEAT.REQUIRED_ERROR,
    helpMessage: PASSWORD_REPEAT.HELP,
    id: PASSWORD_REPEAT.NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: PASSWORD_REPEAT.LABEL,
    name: PASSWORD_REPEAT.NAME,
    onChange: e => setPasswordRepeat(e.target.value),
    type: "password",
    validateFn: validateNewPassword,
    value: passwordRepeat
  }), customButtons ? React.createElement(ButtonRow, {
    buttons: customButtons,
    className: "margin-top-2"
  }) : React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    className: "margin-right-1",
    onClick: onCancel,
    transparent: true
  }, BUTTON_CANCEL_LABEL), React.createElement(Button, {
    className: "button-width-150",
    focus: true,
    inverted: true,
    type: "submit"
  }, BUTTON_CONFIRM_LABEL)));
};
svs.ticket_partner.changePassword.ChangePasswordForm = ChangePasswordForm;

 })(window);